import React from 'react'
import { TimerTheme, TimerThemeProps } from '../types'

/**
 * 一般主題組件 - 簡潔無特效的默認主題
 */
const NormalThemeComponent: React.FC<TimerThemeProps> = ({ children }) => {
  // 一般主題不添加任何包裝，直接返回子元素
  return <>{children}</>
}

/**
 * 一般主題定義
 */
const NormalTheme: TimerTheme = {
  config: {
    name: 'normal',
    displayName: '一般主題',
    colors: {
      runningPrimary: 'text-green-600',
      runningSecondary: 'bg-green-500',
      runningAccent: 'bg-green-400',
      stoppedPrimary: 'text-secondary-600',
      stoppedSecondary: 'bg-gray-400',
      stoppedAccent: 'bg-gray-300',
      runningBackground: 'bg-gradient-to-br from-green-50 to-emerald-50',
      stoppedBackground: 'bg-gradient-to-br from-gray-50 to-slate-50',
    },
    hasSpecialEffects: false,
  },
  Component: NormalThemeComponent,
}

export default NormalTheme
